import React, { useEffect, useState, useRef } from "react";
import CheckIcon from "@mui/icons-material/Check";
import { useSnackbar } from "notistack";
import ResourcesDropdown from "./ResourcesDropdown";

const AssignedPersonList = ({
  selectedActions,
  setSelectedActions,
  employees,
  entries,
  tasks,
  items,
  setIsSelfChecked,
  isSelfChecked,
  setselectedselfemail,
  setManagerSelectedEmpOnChange,
  row,
  dropdownRef,
  handleTaskTableClick,
  SetShowprojectDetails,
  setManagerViewEmpTask,
  setManagerSelectedEmp,
  setRowsManager,
  setSourceName,
  handleMenuToggle,
  handleManagerAction,
  setSelectedEmail,
  setSelectedProject,
  setSelectedServiceType,
  setManagerOPID,
  setManagerOPProject,
  setRows,
  setTaskTableRowId,
  handleComplete,
  setopemail,
  index,
  dropdownRefs,
  handleDropdownChange,
  openDropdownIndex,
  setOpenDropdownIndex,
  assignedPeopleList,
  employeesfinalList,
  setAssignedPeopleList,
  setServiceofuser,
  SetisLoading,
  handleforwardself,
  handleCompleteself,
  handleselfcancel,
  setIsOpen,
  isOpen,
  setSelectedActionComplete,
  selectedActionComplete,
  setSelectedSelfAction,
  selectedSelfAction,
  handleselfreview,
  setIsSelfChecke,
  isSelf,
  isViewOnly = false,
  showprojectDetails = false,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const userEmail = localStorage.getItem("email");
  const userName = localStorage.getItem("name");
  const userLastName = localStorage.getItem("lastName");
  const tableRef = useRef(null);
  const prevManagerActionRef = useRef(null);
  const [showComplate, setShowComplate] = useState("");
  const [showstatus, setshowstatus] = useState("");
  const [manager, setmanager] = useState("");
  const [selectedNameId, setSelectedNameId] = useState(null);
  const filteredPersons = React.useMemo(
    () =>
      row.Assignedperson?.filter(
        (person) => person.email !== localStorage.getItem("email")
      ) || [],
    [row.Assignedperson]
  );

  const getActionText = (person) => {
    // First check if completed - this should take highest priority
    if (
      person.manageraction === "complete" &&
      person.taskStatus === "submit"
    ) {
      return "Completed";
    }
    if (person.operationaction === "reject") return "Rejected";
    if (
      (person.taskStatus === "autosave" || person.taskStatus === "pending") &&
      (person.operationaction !== "reject" ||
        person.operationaction !== "accept")
    )
      return "Pending";
    if (
      (person.taskStatus === "submit" &&
        person?.operationaction === "accept") ||
      person.taskStatus === "submit"
    )
      return "Accepted";
    if (person.manageraction === "review") return "Review";
    if (person.manageraction === "reminder") return "Pending";
    if (person.manageraction === "cancel") return "Cancelled";

    return "Pending";
  };
  // Handle clicking on a person's name
  const handlePersonClick = (row, person) => {
    if (isViewOnly) return;
    handleTaskTableClick(row._id);
    SetShowprojectDetails(false);
    setManagerViewEmpTask(true);
    setManagerSelectedEmp({ row, person });

    const filtered =
      row?.WorkEntries?.filter(
        (entry) =>
          entry?.createdBy?.name?.trim().toLowerCase() ===
          person?.name?.trim().toLowerCase()
      ) || [];

    setRowsManager(
      filtered.length > 0
        ? filtered
        : [{ task: "", hoursassigned: "", notes: "" }]
    );
    setSourceName(person.name);
    setSelectedEmail(person.email);
    setSelectedProject(row.ProjectName);
    setSelectedServiceType(row.TypeService);
  };

  const getManagerStatus = () => {
    const userEmail = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    const matchedEntries = entries.filter(
      (entry) =>
        entry.projectid === row?._id && entry.managerid === currentEmployee?._id
    );
    // Check if any entry in matchedEntries has taskStatus not equal to "manager-submit"
    const hasPendingStatus = matchedEntries.some(
      (entry) => entry.taskStatus !== "submit"
    );

    if (hasPendingStatus) {
      return (
        <span
          title="Pending"
          className="text-orange-500 cursor-default font-bold text-xl"
        >
          !
        </span>
      );
    }
    return null;
  };
  // Helper function to get status indicator
  const getStatusIndicator = (person) => {
    // If task is re-assigned, show orange exclamation mark (pending) even if previously rejected
    if (person.manageraction === "reassign" && person.taskStatus !== "submit") {
      return (
        <span
          title="Reassign"
          className="text-[#ff7720] font-bold text-xl cursor-default"
        >
          !
        </span>
      );
    }
    // Show red exclamation mark only if rejected and not re-assigned
    if (person.operationaction === "reject" && person.manageraction !== "reassign") {
      return (
        <span
          title="Rejected"
          className="text-red-800 cursor-default font-bold text-xl"
        >
          !
        </span>
      );
    }
    if (
      (!person.operationaction && person.taskStatus !== "submit") ||
      person.taskStatus === "autosave" ||
      (person.salespersonaction === "re-assigned" &&
        person.taskStatus !== "submit") ||
      person.taskStatus === "review" ||
      (person.operationaction === "accept" && person.taskStatus !== "submit")
    ) {
      return (
        <span
          title={
            person.salespersonaction === "re-assigned" ? "Reassign" : "Pending"
          }
          className="text-[#ff7720] font-bold text-xl cursor-default"
        >
          !
        </span>
      );
    }
    if (
      person.taskStatus === "submit" ||
      person.salespersonaction === "reject"
    ) {
      return (
        <span title="Accepted" className="cursor-default font-bold text-md">
          <CheckIcon fontSize="small" className=" text-green-600" />
        </span>
      );
    }
    return null;
  };

  useEffect(() => {
    const userEmail = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === userEmail);
    const matchedPerson = row.Assignedperson?.find(
      (person) => person.email?.toLowerCase() === userEmail?.toLowerCase()
    );

    const matchedworkEntries = entries.filter(
      (entry) =>
        entry.projectid === row?._id &&
        entry.taskownerid === currentEmployee?._id
    );

    const matchedtaskEntries = tasks.filter(
      (entry) =>
        entry.projectid === row?._id &&
        entry.taskownerid === currentEmployee?._id
    );

    const matchedhardwareEntries = items.filter(
      (entry) =>
        entry.projectid === row?._id &&
        entry.taskownerid === currentEmployee?._id
    );

    const hasSubmittedworkEntry = matchedworkEntries.some(
      (entry) => entry.taskStatus === "submit"
    );
    const hasSubmittedtaskEntry = matchedtaskEntries.some(
      (entry) => entry.taskstatus === "submit"
    );

    const hasSubmittedhardwareEntry = matchedhardwareEntries.some(
      (entry) => entry.taskstatus === "submit"
    );

    if (
      (hasSubmittedworkEntry ||
        (hasSubmittedworkEntry && hasSubmittedtaskEntry) ||
        (hasSubmittedtaskEntry && hasSubmittedhardwareEntry)) &&
      matchedPerson?.salespersonaction !== "reject"
    ) {
      setShowComplate("complate");
    } else {
      setShowComplate("");
    }
    const managerAssignment = row.Assignedperson?.find(
      (person) => person.email === userEmail
    );
    setshowstatus(managerAssignment);
  }, [row, employees, entries, showComplate, items, tasks, userEmail]);

  const matchedPerson = row.Assignedperson?.find(
    (person) => person.email?.toLowerCase() === userEmail?.toLowerCase()
  );

  console.log("fsfsgsdg", matchedPerson);
  console.log("fsfsgsdg row", row);

  const handleSelfSelect = (isChecked) => {
    if (isViewOnly) return;
    setIsSelfChecked(isChecked);

    if (isChecked) {
      setIsSelfChecke(true);
      setSelectedNameId(null);
      handleforwardself(row);
      setselectedselfemail(userEmail);
      setSourceName(`${userName} ${userLastName}`);
      setManagerViewEmpTask(false);
      setManagerSelectedEmpOnChange(row);
      SetShowprojectDetails(true);
      handleTaskTableClick(row._id);
      setRows(
        Array.isArray(row.WorkEntries) && row.WorkEntries.length > 0
          ? row.WorkEntries
          : [{ task: "", hoursassigned: "", notes: "" }]
      );

      if (!row.Assignedperson?.some((p) => p.email === userEmail)) {
        setManagerSelectedEmpOnChange({
          ...row,
          Assignedperson: [
            ...(row.Assignedperson || []),
            { email: userEmail, name: `${userName} ${userLastName}` },
          ],
        });
      }
    } else {
      setselectedselfemail("");
      setSourceName("");
      setTaskTableRowId(null);
      SetShowprojectDetails(false);
      setManagerViewEmpTask(false);
      setManagerSelectedEmpOnChange(row);
      setIsSelfChecke(false);
    }
  };

  const handleSelfCheckboxChange = (e) => {
    if (isViewOnly) return;
    e.stopPropagation();
    setServiceofuser(row.TypeService);
    handleSelfSelect(e.target.checked);
  };

  const handleSelfTextClick = () => {
    if (isViewOnly) return;
    // If Self looks selected but the Effort Expenses panel was cleared
    // (e.g. after switching buckets), reopen details instead of toggling off.
    if (isSelf && showprojectDetails) {
      handleSelfSelect(false);
    } else {
      setServiceofuser(row.TypeService);
      SetShowprojectDetails(true);
      handleSelfSelect(true);
    }
  };

  const handleRejectOP = (person) => {
    enqueueSnackbar(`Project Rejected By ${person?.name}`, {
      variant: "error",
    });
    setTaskTableRowId(null);
    setSelectedNameId(null);
    setIsSelfChecke(false);
  };

  const handleSelectClick = (value) => {
    if (isViewOnly) return;
    if (value === "complete") {
      handleOptionClick(row);
    } else if (value === "Cancel") {
      handleselfcancel(row);
    } else if (value === "Review") {
      handleselfreview(row);
    }
  };

  const handleOptionClick = (row) => {
    handleCompleteself(row);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, setIsOpen, dropdownRef]);

  useEffect(() => {
    const userEmail = localStorage.getItem("email");
    const managerAssignment = row.Assignedperson?.find(
      (person) => person.email === userEmail
    );
    setmanager(managerAssignment);
    setshowstatus(managerAssignment);

    // Reset selectedSelfAction when manageraction changes (after API update)
    const currentManagerAction = managerAssignment?.manageraction;
    const currentTaskStatus = managerAssignment?.taskStatus;
    
    // If status is complete, always reset selectedSelfAction to show "Completed"
    if (
      currentManagerAction === "complete" &&
      currentTaskStatus === "submit"
    ) {
      setSelectedSelfAction("");
    } else if (
      prevManagerActionRef.current !== null &&
      prevManagerActionRef.current !== currentManagerAction
    ) {
      // Status changed, reset the selected action to show the updated status
      setSelectedSelfAction("");
    }
    prevManagerActionRef.current = currentManagerAction;
  }, [row, setSelectedSelfAction]);

  return (
    <div className="w-full">
      <div ref={tableRef} className="slectedassignperson w-full text-xs pr-2">
        <div className="body flex w-full">
          <div className="w-[60%] relative flex justify-between items-center border-b text-xs">
            {(matchedPerson?.salespersonaction === "re-assigned" &&
              matchedPerson?.taskStatus !== "submit") ||
            (row?.ProjectManagerAction === "forward" &&
              matchedPerson?.taskStatus === "pending") ? (
              <label className="Pendinglable flex justify-between cursor-pointer p-1 items-center w-full">
                <p
                  className={`p-1 px-3 rounded-md inline-block ${
                    isSelf ? "bg-blue-500 text-white" : ""
                  }`}
                  onClick={handleSelfTextClick}
                >
                  Self
                </p>
                <span
                  title={
                    matchedPerson?.salespersonaction === "re-assigned"
                      ? "Reassign"
                      : "Pending"
                  }
                  className="text-orange-500 cursor-default font-bold text-xl"
                >
                  !
                </span>
              </label>
            ) : (matchedPerson?.manageraction === "complete" &&
                matchedPerson?.salespersonstatus === "response received") ||
              matchedPerson?.taskStatus === "submit" ? (
              <label className="greeticklable flex justify-between  py-2 px-1 items-center w-full">
                <p
                  className={`p-1 cursor-pointer px-3 rounded-md inline-block ${
                    isSelf ? "bg-blue-500 text-white" : "bg-white"
                  }`}
                  onClick={handleSelfTextClick}
                >
                  Self
                </p>
                <span title="Accepted" className=" font-bold text-md">
                  <CheckIcon
                    fontSize="small"
                    className="text-green-600 text-[5px]"
                  />
                </span>
              </label>
            ) : (
              <label className="inputlable flex justify-between cursor-pointer p-2 items-center w-full">
                <p
                  className={`p-1 px-3 rounded-md inline-block ${
                    isSelf ? "bg-blue-500 text-white" : ""
                  }`}
                >
                  Self
                </p>
                <div>
                  <input
                    type="checkbox"
                    checked={isSelfChecked}
                    onChange={handleSelfCheckboxChange}
                    className="w-4 h-4"
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </label>
            )}
            <div className="absolute right-2 flex justify-center align-middle items-center">
              {getManagerStatus()}
            </div>
          </div>

          <div className="w-[40%] flex justify-center align-middle items-center border-b">
            <div
              ref={dropdownRef}
              className="relative flex rounded-xl w-[90%] text-xs items-center"
            >
              <select
                disabled={isViewOnly}
                className={`z-[999] bg-white hover:bg-slate-200 left-0 w-full p-1 overflow-y-auto border rounded-md border-gray-300 flex flex-col ${isViewOnly ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                value={
                  showstatus?.manageraction === "complete" &&
                  showstatus?.taskStatus === "submit"
                    ? ""
                    : selectedSelfAction || ""
                }
                onChange={(e) => {
                  if (isViewOnly) return;
                  const value = e.target.value;
                  setSelectedSelfAction(value);

                  if (!value) return;
                  handleSelectClick(value);
                }}
              >
                <option value="" hidden className="cursor-default tag">
                  {showstatus?.manageraction === "complete" &&
                  showstatus?.taskStatus === "submit"
                    ? "Completed"
                    : showstatus?.manageraction === "review"
                    ? "Review"
                    : showstatus?.salespersonaction === "re-assigned" &&
                      showstatus?.taskStatus === "pending"
                    ? "Pending"
                    : showstatus?.taskStatus === "submit"
                    ? "Accepted"
                    : "Pending"}
                </option>

                {showstatus?.manageraction !== "complete" &&
                  showstatus?.taskStatus === "submit" &&
                  (showstatus?.salespersonaction === "re-assigned" ||
                    showstatus?.salespersonstatus !== "response received") && (
                    <>
                      <option
                        value="Review"
                        className="cursor-pointer hover:bg-slate-100 z-[999]"
                      >
                        Review
                      </option>
                      <option
                        value="complete"
                        className="cursor-pointer hover:bg-slate-100 z-[999]"
                      >
                        Complete
                      </option>
                    </>
                  )}

                {!row.TypeService.toLowerCase().includes("hardware") &&
                  manager &&
                  (manager.taskStatus === "Pending" ||
                    manager.manageraction !== "complete") && (
                    <option
                      value="Cancel"
                      className="p-1 hover:bg-[#e0e0e6] cursor-pointer rounded-md"
                    >
                      Cancel
                    </option>
                  )}
              </select>
            </div>
          </div>
        </div>

        {filteredPersons.map((person, idx) => {
          const personKey = `${row._id}-${person._id}`;
          const selectedValue = selectedActions[personKey] || "";
          return (
            <div
              key={`${row._id}-${idx}_${person?.name}`}
              className="body flex w-full"
            >
              {/* Employee Name Column */}
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  handleMenuToggle(row._id, person);
                }}
                className="w-[60%] p-1 flex justify-between items-center border-b"
              >
                <span
                  onClick={
                    person.operationaction === "reject"
                      ? () => handleRejectOP(person)
                      : () => {
                          handlePersonClick(row, person);
                          setManagerOPID(person);
                          setManagerOPProject(row);
                          setopemail(person.email);
                          setServiceofuser(row.TypeService);
                          setSelectedNameId((prev) =>
                            prev === `${row._id}-${person._id}`
                              ? null
                              : `${row._id}-${person._id}`
                          );
                          setIsSelfChecke(null);
                        }
                  }
                  className={`p-1 rounded-md text-xs text-black  ${
                    person?.operationaction === "reject"
                      ? "cursor-default"
                      : "cursor-pointer"
                  } flex-wrap truncate ${
                    selectedNameId === `${row._id}-${person._id}`
                      ? "bg-blue-500 text-white"
                      : "bg-white"
                  }`}
                >
                  {person.name}
                </span>
                {getStatusIndicator(person)}
              </div>

              {/* Action Column */}
              <div className="w-[40%] flex justify-center align-middle items-center border-b">
                <div
                  ref={dropdownRef}
                  className="relative flex rounded-xl w-[90%] items-center bg-green-300"
                >
                  <select
                    disabled={isViewOnly}
                    className={`z-50 bg-white hover:bg-slate-200 left-0 w-full overflow-y-auto p-1 text-xs border border-gray-300 rounded-md flex flex-col ${isViewOnly ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                    onChange={(e) => {
                      if (isViewOnly) return;
                      const value = e.target.value;

                      setSelectedActions((prev) => ({
                        ...prev,
                        [personKey]: value,
                      }));

                      if (!value) return;
                      handleManagerAction(value, person, row);
                    }}
                    value={selectedValue}
                  >
                    <option value="" hidden className="cursor-default tag">
                      {person.manageraction === "reminder" &&
                      person.operationaction !== "reject" &&
                      person.operationaction !== "accept"
                        ? "Reminder"
                        : person.manageraction === "complete" &&
                          person.salespersonaction !== "re-assigned"
                        ? "Completed"
                        : person.manageraction === "cancel"
                        ? "Cancelled"
                        : getActionText(person)}
                    </option>

                    {((person.taskStatus === "submit" &&
                      person.manageraction !== "complete") ||
                      person.salespersonaction === "reject") &&
                      person.operationaction !== "reject" && (
                      <option
                        value="review"
                        className="px-1 cursor-pointer z-50"
                      >
                        Review
                      </option>
                    )}

                    {((person.taskStatus === "submit" &&
                      person.manageraction !== "complete") ||
                      (person.salespersonaction === "reject" &&
                        person.salespersonstatus !== "response received")) &&
                      person.operationaction !== "reject" && (
                      <option
                        value="complete"
                        className="px-1 cursor-pointer hover:bg-slate-100 z-50"
                      >
                        Complete
                      </option>
                    )}

                    {(person.taskStatus === undefined ||
                      person.taskStatus === "autosave" ||
                      person.salespersonaction === "reject") &&
                      person.manageraction !== "complete" &&
                      person.operationaction !== "reject" && (
                        <option
                          value="reminder"
                          className="px-1 cursor-pointer z-50"
                        >
                          Reminder
                        </option>
                      )}
                    {person.operationaction === "reject" && (
                      <option
                        value="reassign"
                        className="px-1 cursor-pointer z-50"
                      >
                        Reassign
                      </option>
                    )}

                    {(person.salespersonstatus !== "response received" ||
                      person.manageraction !== "complete" ||
                      person.salespersonaction === "re-assigned") && (
                      <option
                        value="cancel"
                        className="px-1 cursor-pointer z-50"
                      >
                        Cancel
                      </option>
                    )}
                  </select>
                </div>
              </div>
            </div>
          );
        })}

        <div className="body flex w-full">
          <div className="w-[60%] relative flex justify-between items-center text-xs">
            <ResourcesDropdown
              index={index}
              row={row}
              dropdownRefs={dropdownRefs}
              handleDropdownChange={handleDropdownChange}
              openDropdownIndex={openDropdownIndex}
              setOpenDropdownIndex={setOpenDropdownIndex}
              assignedPeopleList={assignedPeopleList}
              employeesfinalList={employeesfinalList}
              setAssignedPeopleList={setAssignedPeopleList}
              isViewOnly={isViewOnly}
            />
          </div>

          <div className="w-[40%] flex justify-center align-middle items-center"></div>
        </div>
      </div>
    </div>
  );
};

export default AssignedPersonList;
